import { Spinner } from "@heroui/react";
import { ButtonGradient } from "@/components/ButtonGradient";
import { useRunCalc } from "@/hooks/useRunCalc";
import { Clients } from "../../../lib/clients";

const D1RecalculateButton = () => {
  const runCalcMutation = useRunCalc({ client: Clients.D1 });

  const isSubmitting = runCalcMutation.isPending;

  const handleRecalculate = async () => {
    try {
      await runCalcMutation.mutateAsync();
    } catch (err) {
      console.error("Recalculation failed", err);
    }
  };

  return (
    <ButtonGradient
      onPress={handleRecalculate}
      color="purple"
      isDisabled={isSubmitting}
      startContent={isSubmitting ? <Spinner size="sm" color="primary" /> : null}
    >
      {isSubmitting ? "Recalcul..." : "Recalculer"}
    </ButtonGradient>
  );
};

export default D1RecalculateButton;
